
  import { Vue, Component, Prop } from "vue-property-decorator";
  // @ts-ignore
  import VueSkeletonLoader from "skeleton-loader-vue";

  type Animation = "fade" | "wave" | "pulse" | "pulse-x" | "pulse-y";

  @Component({
    components: {
      VueSkeletonLoader,
    },
  })
  export default class Skeleton extends Vue {
    @Prop({ type: Number, required: true }) readonly width!: number;
    @Prop({ type: Number, required: true }) readonly height!: number;
    @Prop({ type: String, default: "wave" }) readonly animation!: Animation;
    @Prop({ type: String, default: undefined }) readonly bgColor?: string;
    @Prop({ type: String, default: undefined }) readonly waveColor?: string;
    @Prop({ type: String, default: "rect" }) readonly type!: "rect" | "circle";
  }
